module.exports = __webpack_public_path__ + "img/xinjian.15ab3de8.png";